import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';
//import { slideType } from 'app/models/slideType.model';


@Injectable({ providedIn: 'root' })
export class SlideTypeLinesService {
  private apiUrl = `${environment.baseUrl}/slidetype`;

  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }

  getslideTypeList(): Observable<any> {
    // return this.http.get(`${this.apiUrl}/getAllslideTypes`);
    

    return this.commonAPI.getApiCall(`${this.apiUrl}/getAllslideTypes`);
  }

  getslideTypeWithSC(shortcode: string): Observable<any> {
    // debugger;
    console.log(`${this.apiUrl}/getslideTypeWithSC/${shortcode}`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getslideTypeWithSC/${shortcode}`);
    // return this.http.get(`${this.apiUrl}/getslideTypeWithSC/${shortcode}`);
  }

  getslideTypeLinesByShortCode(shortcode: string): Observable<any> {
    console.log(`${this.apiUrl}/getslideTypeLinesByShortCode/${shortcode}`);
    // let aaa = this.http.get(`${this.apiUrl}/getslideTypeLinesByShortCode/${shortcode}`);
    // console.log(aaa);

    let aaa =  this.commonAPI.getApiCall(`${this.apiUrl}/getslideTypeLinesByShortCode/${shortcode}`);
    console.log(aaa);
    return aaa;
    // return this.http.get(`${this.apiUrl}/getslideTypeLinesByShortCode/${shortcode}`);
  }

  getCustomLayoutsListforPick(): Observable<any> {
    console.log(`${this.apiUrl}/getCustomLayoutsListforPick`);
    // let aaa = this.http.get(`${this.apiUrl}/getCustomLayoutsListforPick`);
    // console.log(aaa);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getCustomLayoutsListforPick`);
    // return this.http.get(`${this.apiUrl}/getCustomLayoutsListforPick`);
  }

  saveslideType(slideType: any): Observable<any> {
    console.log(slideType);

     const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
//slideTypeShortcode, slideTypeName, slidetypeRemarks, slideLayoutShortcode, details,
        "slideTypeShortcode": slideType.slideTypeShortcode,
        "slideTypeName": slideType.slideTypeName,
        "slidetypeRemarks": slideType.slidetypeRemarks,
        "slideLayoutShortcode": slideType.slideLayoutShortcode,
        "ReadingMaterial": slideType.ReadingMaterial || '',
        "details": slideType.details,

        "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.apiUrl}/saveSlideType`, body);
   
 
    
    // return this.http.post(`${this.apiUrl}/saveSlideType`, slideType);
  }

  getSlideTypeMasterCodes(filtername: string): Observable<any> {
    debugger;
    console.log(`${this.apiUrl}/getSlideTypeMasterCodes/${filtername}`);

    let aaa =  this.commonAPI.getApiCall(`${this.apiUrl}/getSlideTypeMasterCodes/${filtername}`);
    console.log(aaa);
    return aaa;
    // return this.http.get(`${this.apiUrl}/getSlideTypeMasterCodes/${filtername}`);
  }

  deleteSlideType(shortcode: string): Observable<any> {
//slideTypeShortcode

const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {
      "criteria": {
//slideTypeShortcode, slideTypeName, slidetypeRemarks, slideLayoutShortcode, details,
        "slideTypeShortcode": shortcode,
                "tenant": null
      }
    };

    return this.commonAPI.postApiCall(`${this.apiUrl}/deleteSlideType`, body);
   
// return this.http.delete(`${this.apiUrl}/deleteSlideType/${shortcode}`);
  }
}
